module.exports = __webpack_public_path__ + "static/media/Logo-TCF-rvb.4a42b499.jpg";